import Logo from "../../../assets/logos/Oasis_1c_blk.png"

const LogoBlue = () => {
    return (
        <img
            src={Logo}
            width="113px"
            height="56px"
            alt="oasis-logo"
        />
    )
}

export default LogoBlue;